//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formPage from './form'


export default {
    components: { formPage },
    props: [],
    data () {
        return {
            activeName:"first",

            tableData: [],
            addAuditBtn:true,
            ids:"",
            pgData: {},

            dialogVisible: false,
            dialogTitle: '',

            dialogVisible_branch: false,
            dialogTitle_branch: '',

            formSearch: {
                id: ''
            },

            /* 我的审核 */
            myTableData:[],
            myPgData: {},
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        },
        dialogVisible_branch(n, o) {
            !n && this.reloadHandler();
        }
    },
    methods: {
        handleClick(){
            this.$refs.pgData.reload();
            this.$refs.myPage.reload();
        },
        detailHandler(row){
            sessionStorage.setItem('id',row.id);
            sessionStorage.setItem('type','detail');
            this.goto('./detail');
        },
        auditHandler(row) {
            sessionStorage.setItem('id',row.id);
            sessionStorage.setItem('type','audit');
            this.goto('./detail');
        },
        myReloadHandler(){
            this.$refs.myPage.reload();
        },
        reloadHandler() {
            this.$refs.page.reload();
        },
        selectable(row){
            return true;
        },
        getRowKeys:function(row){
            return row.id;
        },
        addAudit(){
            this.$post(this.getStore('bankguart') + '/gua_audit/add_audit',{
                ids:this.ids
            },(data)=>{
                this.activeName = "first";
                this.$refs.page.reload();
                this.$refs.myPage.reload();
            })
        },
        handleSelectionChange(val){
            if(val.length > 0){
                this.addAuditBtn = false;
                this.ids = "";
                for(var i = 0;i < val.length;i++){
                    this.ids += val[i].id + ',';
                }
            }else{
                this.addAuditBtn = true;
            }
        },

        /* 我的审核 */
    },
    mounted: function() {

    }
}
